import React from 'react';
import { Text } from '@fragments';
import SocialAvatar from '../../../../components/SocialAvatar';
import { formatDate } from '../../../../data/payments';
import './styles.scss';

// Who the selected profile is: its photo, @ and name, and when the @ onboarding connected
// it. Every profile is presented alike: none is primary (contract 2.0.0).
export default function ProfileIdentity({ studio: s, profile }) {
  const { t } = s;
  const locale = s.locale.replace('_', '-');
  const connected = profile.timestamps?.connected;
  const origin = connected ? t('profileConnectedOn', { date: formatDate(connected, locale) }) : null;
  const meta = [profile.name, origin].filter(Boolean).join(' · ');
  return <header className="studio-profile-identity">
    <SocialAvatar className="studio-profile-identity__avatar" picture={profile.picture} label={profile.handle} platform={profile.platform} />
    <div className="studio-profile-identity__text">
      <Text.h5 weight={500} contrast={9} maxLines={1}>{`@${profile.handle}`}</Text.h5>
      {meta && <Text.span contrast={6} maxLines={2}>{meta}</Text.span>}
    </div>
  </header>;
}
